import {createContext,useContext,useEffect,useState,useCallback,useRef} from "react";
import {api,apiErrorMessage} from "@/lib/api";
const AuthContext=createContext(null);
export function AuthProvider({children}){
 const [user,setUser]=useState(null),[loading,setLoading]=useState(true),[sessionError,setSessionError]=useState("");
 const generation=useRef(0),controller=useRef(null);
 const checkSession=useCallback(async()=>{
  const version=++generation.current;controller.current?.abort();
  const c=new AbortController();controller.current=c;setLoading(true);setSessionError("");
  try{const {data}=await api.get("/auth/me",{signal:c.signal,timeout:15000});if(version===generation.current)setUser(data);}
  catch(e){if(version!==generation.current||e.code==="ERR_CANCELED")return;
   setUser(false);
   if([401,403].includes(e.response?.status)){localStorage.removeItem("mega20_token");setSessionError("");}
   else setSessionError("Não foi possível verificar sua sessão. Confira a conexão e tente novamente.");
  }finally{if(version===generation.current)setLoading(false);}
 },[]);
 useEffect(()=>{checkSession();return()=>{generation.current++;controller.current?.abort();};},[checkSession]);
 const login=async(email,password)=>{
  const version=++generation.current;controller.current?.abort();setSessionError("");
  try{const {data}=await api.post("/auth/login",{email,password});if(version!==generation.current)return {ok:false,error:"A solicitação de acesso foi cancelada."};
   if(data.token)localStorage.setItem("mega20_token",data.token);else localStorage.removeItem("mega20_token");
   setUser(data.user);setLoading(false);return {ok:true};
  }catch(e){if(version===generation.current)setLoading(false);return {ok:false,error:apiErrorMessage(e)};}
 };
 const logout=async()=>{
  generation.current++;controller.current?.abort();setLoading(false);setSessionError("");
  try{await api.post("/auth/logout",{}, {timeout:15000});}catch{return {ok:false,error:"Não foi possível sair. Confira a conexão e tente novamente."};}
  localStorage.removeItem("mega20_token");setUser(false);return {ok:true};
 };
 return <AuthContext.Provider value={{user,loading,sessionError,login,logout,checkSession}}>{children}</AuthContext.Provider>;
}
export const useAuth=()=>useContext(AuthContext);
